import * as React from "react"

/**
 * @typedef {React.ImgHTMLAttributes<HTMLImageElement>} ImgProps
 */

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const GiantId = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_825_2763)">
      <circle cx="16" cy="16" r="16" fill="#D9E2EA" />
      <path
        d="M9 7.0297L23 7C22.7576 8.32885 22.1228 9.51511 21.6939 10.7746C21.5419 11.2202 21.1841 11.0935 20.8879 11.0955C18.8392 11.0955 16.7925 11.0955 14.7458 11.0955C14.4361 11.0955 14.1129 11.0044 13.7648 11.2183L16.0212 17.3159L20.7475 12.7194L20.9398 12.8204C19.3278 17.1496 17.7159 21.4807 16.0346 26C15.0016 23.2274 14.0245 20.643 13.0627 18.0467C11.7007 14.3724 10.3465 10.7001 9 7.0297Z"
        fill="#353F58"
      />
    </g>
    <defs>
      <clipPath id="clip0_825_2763">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const GiantIdDark = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6488_32291)">
      <circle cx="16" cy="16" r="16" fill="#5A6D96" />
      <path
        d="M9 7.0297L23 7C22.7576 8.32885 22.1228 9.51511 21.6939 10.7746C21.5419 11.2202 21.1841 11.0935 20.8879 11.0955C18.8392 11.0955 16.7925 11.0955 14.7458 11.0955C14.4361 11.0955 14.1129 11.0044 13.7648 11.2183L16.0212 17.3159L20.7475 12.7194L20.9398 12.8204C19.3278 17.1496 17.7159 21.4807 16.0346 26C15.0016 23.2274 14.0245 20.643 13.0627 18.0467C11.7007 14.3724 10.3465 10.7001 9 7.0297Z"
        fill="#EFF2F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_6488_32291">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const UserName = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_825_2853)">
      <circle cx="16" cy="16" r="16" fill="#D9E2EA" />
      <circle cx="16" cy="10.95" r="4.25" fill="#353F58" />
      <path
        d="M9.95986 19.3759L8.95796 21.0103C8.6585 21.4988 8.5 22.0606 8.5 22.6336C8.5 23.9405 9.55875 25 10.8657 25H15.7772H21.1347C22.4416 25 23.5 23.9405 23.5 22.6336C23.5 22.0606 23.3415 21.4988 23.042 21.0103L22.0401 19.3759C20.7544 17.2785 18.4602 16 16 16C13.5398 16 11.2456 17.2785 9.95986 19.3759Z"
        fill="#353F58"
      />
    </g>
    <defs>
      <clipPath id="clip0_825_2853">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const UserNameDark = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6488_32292)">
      <circle cx="16" cy="16" r="16" fill="#5A6D96" />
      <circle cx="16" cy="10.95" r="4.25" fill="#EFF2F7" />
      <path
        d="M9.95986 19.3759L8.95796 21.0103C8.6585 21.4988 8.5 22.0606 8.5 22.6336C8.5 23.9405 9.55875 25 10.8657 25H15.7772H21.1347C22.4416 25 23.5 23.9405 23.5 22.6336C23.5 22.0606 23.3415 21.4988 23.042 21.0103L22.0401 19.3759C20.7544 17.2785 18.4602 16 16 16C13.5398 16 11.2456 17.2785 9.95986 19.3759Z"
        fill="#EFF2F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_6488_32292">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Gender = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_825_2903)">
      <circle cx="16" cy="16" r="16" fill="#D9E2EA" />
      <circle cx="15.7972" cy="7.71671" r="2.21671" fill="#353F58" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4184 10.0648L16.556 10.0648C16.6288 10.0518 16.7041 10.0463 16.781 10.049C17.9496 10.0908 18.9076 10.4809 19.6501 11.1259C20.3773 11.7576 20.8395 12.5821 21.1287 13.4139C21.6994 15.0551 21.6697 16.9299 21.4865 18.1515C21.3996 18.7308 20.8596 19.13 20.2803 19.0431C19.701 18.9562 19.3019 18.4161 19.3888 17.8369C19.5414 16.8194 19.5453 15.3187 19.1252 14.1107C18.9267 13.5399 18.6511 13.0842 18.3 12.7638V18.7118C18.3046 18.7518 18.3069 18.7926 18.3069 18.8339V25.3832C18.3069 25.969 17.8321 26.4438 17.2463 26.4438C16.6606 26.4438 16.1857 25.969 16.1857 25.3832V19.1697H15.6204V25.3832C15.6204 25.969 15.1456 26.4438 14.5598 26.4438C13.9741 26.4438 13.4992 25.969 13.4992 25.3832V18.8339C13.4992 18.8202 13.4995 18.8066 13.5 18.793V12.9409C13.2308 13.2443 13.0135 13.638 12.8492 14.1107C12.4291 15.3187 12.433 16.8194 12.5856 17.8369C12.6725 18.4161 12.2733 18.9562 11.6941 19.0431C11.1148 19.13 10.5748 18.7308 10.4879 18.1515C10.3046 16.9299 10.2749 15.0551 10.8456 13.4139C11.1349 12.5821 11.597 11.7576 12.3242 11.1259C13.0667 10.4809 14.0247 10.0908 15.1934 10.049C15.2703 10.0463 15.3456 10.0518 15.4184 10.0648Z"
        fill="#353F58"
      />
    </g>
    <defs>
      <clipPath id="clip0_825_2903">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const GenderDark = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6488_32293)">
      <circle cx="16" cy="16" r="16" fill="#5A6D96" />
      <circle cx="15.7972" cy="7.71671" r="2.21671" fill="#EFF2F7" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4184 10.0648L16.556 10.0648C16.6288 10.0518 16.7041 10.0463 16.781 10.049C17.9496 10.0908 18.9076 10.4809 19.6501 11.1259C20.3773 11.7576 20.8395 12.5821 21.1287 13.4139C21.6994 15.0551 21.6697 16.9299 21.4865 18.1515C21.3996 18.7308 20.8596 19.13 20.2803 19.0431C19.701 18.9562 19.3019 18.4161 19.3888 17.8369C19.5414 16.8194 19.5453 15.3187 19.1252 14.1107C18.9267 13.5399 18.6511 13.0842 18.3 12.7638V18.7118C18.3046 18.7518 18.3069 18.7926 18.3069 18.8339V25.3832C18.3069 25.969 17.8321 26.4438 17.2463 26.4438C16.6606 26.4438 16.1857 25.969 16.1857 25.3832V19.1697H15.6204V25.3832C15.6204 25.969 15.1456 26.4438 14.5598 26.4438C13.9741 26.4438 13.4992 25.969 13.4992 25.3832V18.8339C13.4992 18.8202 13.4995 18.8066 13.5 18.793V12.9409C13.2308 13.2443 13.0135 13.638 12.8492 14.1107C12.4291 15.3187 12.433 16.8194 12.5856 17.8369C12.6725 18.4161 12.2733 18.9562 11.6941 19.0431C11.1148 19.13 10.5748 18.7308 10.4879 18.1515C10.3046 16.9299 10.2749 15.0551 10.8456 13.4139C11.1349 12.5821 11.597 11.7576 12.3242 11.1259C13.0667 10.4809 14.0247 10.0908 15.1934 10.049C15.2703 10.0463 15.3456 10.0518 15.4184 10.0648Z"
        fill="#EFF2F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_6488_32293">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Birth = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_825_2969)">
      <circle cx="16" cy="16" r="16" fill="#D9E2EA" />
      <rect
        x="8.2002"
        y="9.70264"
        width="15.6"
        height="2.92899"
        rx="1.4645"
        fill="#353F58"
      />
      <rect
        x="11.1254"
        y="7.75"
        width="2.22857"
        height="4.42604"
        rx="1.11429"
        fill="#353F58"
      />
      <rect
        x="18.4959"
        y="7.75"
        width="2.22857"
        height="4.42604"
        rx="1.11429"
        fill="#353F58"
      />
      <rect
        x="8.97989"
        y="13.9985"
        width="14.1375"
        height="10.2515"
        rx="1.5"
        fill="#353F58"
      />
    </g>
    <defs>
      <clipPath id="clip0_825_2969">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const BirthDark = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6488_32294)">
      <circle cx="16" cy="16" r="16" fill="#5A6D96" />
      <rect
        x="8.2002"
        y="9.70264"
        width="15.6"
        height="2.92899"
        rx="1.4645"
        fill="#EFF2F7"
      />
      <rect
        x="11.1254"
        y="7.75"
        width="2.22857"
        height="4.42604"
        rx="1.11429"
        fill="#EFF2F7"
      />
      <rect
        x="18.4959"
        y="7.75"
        width="2.22857"
        height="4.42604"
        rx="1.11429"
        fill="#EFF2F7"
      />
      <rect
        x="8.97989"
        y="13.9985"
        width="14.1375"
        height="10.2515"
        rx="1.5"
        fill="#EFF2F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_6488_32294">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Measure = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_825_3019)">
      <circle cx="16" cy="16" r="16" fill="#D9E2EA" />
      <rect
        width="17.2069"
        height="10.3242"
        rx="1.41097"
        transform="matrix(0.707106 -0.707108 0.707106 0.707108 6.38475 18.3847)"
        fill="#353F58"
      />
      <path
        d="M8.68674 15.3134L12.0622 18.6889"
        stroke="#D9E2EA"
        strokeWidth="1.33"
      />
      <path
        d="M12.063 11.9379L15.4385 15.3134"
        stroke="#D9E2EA"
        strokeWidth="1.33"
      />
      <path
        d="M15.6635 8.33728L19.039 11.7128"
        stroke="#D9E2EA"
        strokeWidth="1.33"
      />
    </g>
    <defs>
      <clipPath id="clip0_825_3019">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const MeasureDark = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6488_32298)">
      <circle cx="16" cy="16" r="16" fill="#5A6D96" />
      <rect
        width="17.2069"
        height="10.3242"
        rx="1.41097"
        transform="matrix(0.707106 -0.707108 0.707106 0.707108 6.38477 18.3848)"
        fill="#EFF2F7"
      />
      <path
        d="M8.68674 15.3132L12.0622 18.6887"
        stroke="#5A6D96"
        strokeWidth="1.33"
      />
      <path
        d="M12.063 11.938L15.4385 15.3135"
        stroke="#5A6D96"
        strokeWidth="1.33"
      />
      <path
        d="M15.6635 8.33716L19.039 11.7127"
        stroke="#5A6D96"
        strokeWidth="1.33"
      />
    </g>
    <defs>
      <clipPath id="clip0_6488_32298">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Location = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_825_3093)">
      <circle cx="16" cy="16" r="16" fill="#D9E2EA" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6973 25.7198C18.4963 23.3859 22.8897 17.3625 22.8897 14.1988C22.8897 10.2293 19.7819 7 15.9429 7C12.1078 7 9 10.2285 9 14.1988C9 17.3624 13.3907 23.3856 15.1888 25.7196C15.5747 26.2206 16.3112 26.2207 16.6973 25.7198ZM15.9448 17.4172C17.8626 17.4172 19.4172 15.8626 19.4172 13.9448C19.4172 12.0271 17.8626 10.4724 15.9448 10.4724C14.0271 10.4724 12.4724 12.0271 12.4724 13.9448C12.4724 15.8626 14.0271 17.4172 15.9448 17.4172Z"
        fill="#353F58"
      />
    </g>
    <defs>
      <clipPath id="clip0_825_3093">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const LocationDark = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6488_32297)">
      <circle cx="16" cy="16" r="16" fill="#5A6D96" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6973 25.7198C18.4963 23.3859 22.8897 17.3625 22.8897 14.1988C22.8897 10.2293 19.7819 7 15.9429 7C12.1078 7 9 10.2285 9 14.1988C9 17.3624 13.3907 23.3856 15.1888 25.7196C15.5747 26.2206 16.3112 26.2207 16.6973 25.7198ZM15.9448 17.4172C17.8626 17.4172 19.4172 15.8626 19.4172 13.9448C19.4172 12.0271 17.8626 10.4724 15.9448 10.4724C14.0271 10.4724 12.4724 12.0271 12.4724 13.9448C12.4724 15.8626 14.0271 17.4172 15.9448 17.4172Z"
        fill="#EFF2F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_6488_32297">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Email = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_286_14250)">
      <circle cx="10" cy="10" r="10" fill="#DAE2F6" />
      <path
        d="M15 6.9375V13.0625C15 13.4422 14.6922 13.75 14.3125 13.75H5.6875C5.3078 13.75 5 13.4422 5 13.0625V6.9375C5 6.92301 5.00302 6.90879 5.00391 6.89453L9.80176 10.2812L10 10.4209L10.1982 10.2812L14.9951 6.89453C14.996 6.90881 15 6.92299 15 6.9375ZM14.3125 6.25C14.4207 6.25 14.5222 6.27675 14.6133 6.32129L10 9.57812L5.38574 6.32129C5.47701 6.27651 5.57898 6.25 5.6875 6.25H14.3125Z"
        fill="#0050FC"
      />
    </g>
    <defs>
      <clipPath id="clip0_286_14250">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const EmailDark = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6488_32295)">
      <circle cx="16" cy="16" r="16" fill="#5A6D96" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00233 11.0278C8.00079 11.0517 8 11.0757 8 11.1V20.9C8 21.5075 8.49249 22 9.1 22H22.9C23.5075 22 24 21.5075 24 20.9V11.1C24 11.0757 23.9992 11.0517 23.9977 11.0278L16.3172 16.4493L16 16.6732L15.6828 16.4493L8.00233 11.0278ZM23.3862 10.113C23.2396 10.0407 23.0745 10 22.9 10H9.1C8.92546 10 8.76042 10.0407 8.61382 10.113L16 15.3268L23.3862 10.113Z"
        fill="#EFF2F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_6488_32295">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Phone = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_825_3387)">
      <circle cx="16" cy="16" r="16" fill="#D9E2EA" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 8.51316C10 7.81554 10.5655 7.25 11.2632 7.25H19.7895C20.4871 7.25 21.0526 7.81554 21.0526 8.51316V23.4868C21.0526 24.1845 20.4871 24.75 19.7895 24.75H11.2632C10.5655 24.75 10 24.1845 10 23.4868V8.51316ZM16.5267 22.8109C16.5267 23.4116 16.0397 23.8987 15.4389 23.8987C14.8381 23.8987 14.351 23.4116 14.351 22.8109C14.351 22.2101 14.8381 21.723 15.4389 21.723C16.0397 21.723 16.5267 22.2101 16.5267 22.8109ZM13.8781 8.52026C13.6393 8.52026 13.4457 8.71386 13.4457 8.95269C13.4457 9.19151 13.6393 9.38512 13.8781 9.38512H17.189C17.4278 9.38512 17.6214 9.19151 17.6214 8.95269C17.6214 8.71386 17.4278 8.52026 17.189 8.52026H13.8781Z"
        fill="#353F58"
      />
    </g>
    <defs>
      <clipPath id="clip0_825_3387">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const PhoneDark = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6488_32296)">
      <circle cx="16" cy="16" r="16" fill="#5A6D96" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 8.51316C10 7.81554 10.5655 7.25 11.2632 7.25H19.7895C20.4871 7.25 21.0526 7.81554 21.0526 8.51316V23.4868C21.0526 24.1845 20.4871 24.75 19.7895 24.75H11.2632C10.5655 24.75 10 24.1845 10 23.4868V8.51316ZM16.5267 22.8109C16.5267 23.4116 16.0397 23.8987 15.4389 23.8987C14.8381 23.8987 14.351 23.4116 14.351 22.8109C14.351 22.2101 14.8381 21.723 15.4389 21.723C16.0397 21.723 16.5267 22.2101 16.5267 22.8109ZM13.8781 8.52026C13.6393 8.52026 13.4457 8.71386 13.4457 8.95269C13.4457 9.19151 13.6393 9.38512 13.8781 9.38512H17.189C17.4278 9.38512 17.6214 9.19151 17.6214 8.95269C17.6214 8.71386 17.4278 8.52026 17.189 8.52026H13.8781Z"
        fill="#EFF2F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_6488_32296">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Message = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_917_5535)">
      <circle cx="16" cy="16" r="16" fill="#D9E2EA" />
      <path
        d="M8.5 24.2356V11.5C8.5 10.3954 9.39543 9.5 10.5 9.5H22.5C23.6046 9.5 24.5 10.3954 24.5 11.5V19.6827C24.5 20.7872 23.6046 21.6827 22.5 21.6827H12.0788L9.36477 24.5776C9.05476 24.9083 8.5 24.6889 8.5 24.2356Z"
        fill="#353F58"
      />
    </g>
    <defs>
      <clipPath id="clip0_917_5535">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const MessageDark = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6488_32321)">
      <circle cx="16" cy="16" r="16" fill="#5A6D96" />
      <path
        d="M8.5 24.2356V11.5C8.5 10.3954 9.39543 9.5 10.5 9.5H22.5C23.6046 9.5 24.5 10.3954 24.5 11.5V19.6827C24.5 20.7872 23.6046 21.6827 22.5 21.6827H12.0788L9.36477 24.5776C9.05476 24.9083 8.5 24.6889 8.5 24.2356Z"
        fill="#EFF2F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_6488_32321">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Password = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_917_5695)">
      <circle cx="16" cy="16" r="16" fill="#D9E2EA" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5747 8.85119C14.1048 9.41959 13.8527 10.1159 13.8 10.5998V14H21.4076C22.571 14 23.5142 14.9432 23.5142 16.1066V22.5218C23.5142 23.6853 22.571 24.6285 21.4076 24.6285H11.0067C9.84318 24.6285 8.89999 23.6853 8.89999 22.5218V16.1066C8.89999 14.9432 9.84318 14 11.0067 14H12V10.5556V10.5151L12.0036 10.4749C12.08 9.62648 12.4751 8.56599 13.1873 7.70437C13.9166 6.82214 15.0243 6.1 16.5 6.1C18.271 6.1 19.4328 6.9424 20.1193 7.93117C20.7723 8.8718 21 9.94299 21 10.5556C21 11.0526 20.597 11.4556 20.1 11.4556C19.6029 11.4556 19.2 11.0526 19.2 10.5556C19.2 10.2792 19.0676 9.57265 18.6407 8.95772C18.2472 8.39093 17.609 7.9 16.5 7.9C15.6717 7.9 15.0394 8.28897 14.5747 8.85119Z"
        fill="var(--color-primary-dark-blue)"
      />
    </g>
    <defs>
      <clipPath id="clip0_917_5695">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const PasswordDark = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6488_32328)">
      <circle cx="16" cy="16" r="16" fill="#5A6D96" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5747 8.85131C14.1049 9.41971 13.8527 10.116 13.8 10.5999V14.0001H21.4076C22.5711 14.0001 23.5143 14.9433 23.5143 16.1068V22.522C23.5143 23.6854 22.5711 24.6286 21.4076 24.6286H11.0067C9.84322 24.6286 8.90002 23.6854 8.90002 22.522V16.1068C8.90002 14.9433 9.84321 14.0001 11.0067 14.0001H12V10.5557V10.5153L12.0036 10.475C12.08 9.6266 12.4751 8.56612 13.1873 7.70449C13.9166 6.82226 15.0243 6.10012 16.5 6.10012C18.271 6.10012 19.4328 6.94252 20.1193 7.93129C20.7724 8.87192 21 9.94312 21 10.5557C21 11.0527 20.5971 11.4557 20.1 11.4557C19.603 11.4557 19.2 11.0527 19.2 10.5557C19.2 10.2794 19.0677 9.57277 18.6407 8.95784C18.2472 8.39105 17.609 7.90012 16.5 7.90012C15.6717 7.90012 15.0394 8.28909 14.5747 8.85131Z"
        fill="#EFF2F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_6488_32328">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Eeath = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2915_17558)">
      <circle cx="16" cy="16" r="16" fill="#D9E2EA" />
      <circle cx="16" cy="16" r="10" fill="var(--color-primary-dark-blue)" />
      <path
        d="M5.5 15.5H26.5"
        stroke="#D9E2EA"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M17 5C18 6.60976 20 11.0098 20 15.7317C20 20.4537 18 25.2114 17 27"
        stroke="#D9E2EA"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M15 5C14 6.60976 12 11.0098 12 15.7317C12 20.4537 14 25.2114 15 27"
        stroke="#D9E2EA"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2915_17558">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const EarthDark = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6488_32299)">
      <circle cx="16" cy="16" r="16" fill="#5A6D96" />
      <circle cx="16" cy="16" r="10" fill="#EFF2F7" />
      <path
        d="M5.5 15.5H26.5"
        stroke="#5A6D96"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M17 5C18 6.60976 20 11.0098 20 15.7317C20 20.4537 18 25.2114 17 27"
        stroke="#5A6D96"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M15 5C14 6.60976 12 11.0098 12 15.7317C12 20.4537 14 25.2114 15 27"
        stroke="#5A6D96"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6488_32299">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Verify = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_825_3314)">
      <circle cx="16" cy="16" r="16" fill="#005EB8" />
      <path
        d="M23.6002 11L14.6929 22.2L8.79999 14.75"
        stroke="white"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_825_3314">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Unverify = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_825_3331)">
      <circle cx="16" cy="16" r="16" fill="#8890A1" {...props} />
      <path
        d="M22.4991 9.5L9.49995 22.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9.50092 9.5L22.5001 22.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_825_3331">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Warning = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_917_6164)">
      <path
        d="M13.9966 5.25591C14.8192 3.81631 16.895 3.81631 17.7176 5.25591L31.168 28.794C31.9843 30.2225 30.9528 32 29.3074 32H2.40679C0.761452 32 -0.270044 30.2225 0.54627 28.794L13.9966 5.25591Z"
        fill="#5A6D96"
      />
      <path
        d="M17.2309 21.2118C17.2074 21.5934 16.891 21.8909 16.5087 21.8909H15.3517C14.9693 21.8909 14.653 21.5934 14.6295 21.2118L14.1896 14.0681C14.164 13.6517 14.4947 13.3 14.9118 13.3H16.9485C17.3656 13.3 17.6964 13.6517 17.6707 14.0681L17.2309 21.2118ZM14.1 25C14.1 24.3895 14.2763 23.9649 14.629 23.726C14.9816 23.4738 15.4118 23.3478 15.9196 23.3478C16.4133 23.3478 16.8364 23.4738 17.1891 23.726C17.5417 23.9649 17.718 24.3895 17.718 25C17.718 25.5839 17.5417 26.0086 17.1891 26.274C16.8364 26.5262 16.4133 26.6522 15.9196 26.6522C15.4118 26.6522 14.9816 26.5262 14.629 26.274C14.2763 26.0086 14.1 25.5839 14.1 25Z"
        fill="white"
        stroke="#5A6D96"
        strokeWidth="0.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_917_6164">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Apple = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_825_4375)">
      <circle cx="16" cy="16" r="16" fill="black" />
      <path
        d="M19.5388 7.6719C19.4864 7.66432 19.427 7.66906 19.3625 7.68925C18.5027 7.85077 17.558 8.33535 16.9562 8.9007C16.4403 9.38528 16.0108 10.1929 16.0108 10.9198C16.0108 11.0813 16.1814 11.2432 16.3534 11.2432C17.2991 11.1624 18.2452 10.6775 18.847 10.1122C19.3628 9.46604 19.7924 8.73949 19.7924 8.01262C19.7924 7.8309 19.696 7.69461 19.5388 7.6719ZM19.7924 11.1627C18.2448 11.1627 17.558 12.0508 16.5263 12.0508C15.4086 12.0508 14.3769 11.2432 13.0873 11.2432C11.2818 11.2432 8.52992 12.8581 8.52992 16.5732C8.44395 19.9653 11.7114 23.7615 13.6028 23.7615C14.7205 23.7615 14.9788 23.1148 16.5263 23.1148C18.0739 23.1148 18.4178 23.7615 19.5355 23.7615C20.8251 23.7615 21.7708 22.469 22.5446 21.419C22.8885 20.8537 23.1464 20.5313 23.4044 20.0467C23.5763 19.7236 23.404 19.4006 23.0601 19.2391C20.8248 18.1891 20.3955 14.7971 22.8888 13.5856C23.3187 13.3433 23.404 12.8578 23.0601 12.6155C22.1144 11.8079 20.7381 11.1627 19.7924 11.1627Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_825_4375">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Facebook = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_825_4401)">
      <circle cx="16" cy="16" r="16" fill="#3579EA" />
      <path
        d="M24.5272 16.0214C24.5272 11.3026 20.707 7.47281 16 7.47281C11.293 7.47281 7.47281 11.3026 7.47281 16.0214C7.47281 20.1589 10.4062 23.604 14.2946 24.399V18.586H12.5891V16.0214H14.2946V13.8842C14.2946 12.2344 15.6333 10.8922 17.2791 10.8922H19.4109V13.4568H17.7054C17.2365 13.4568 16.8527 13.8415 16.8527 14.3117V16.0214H19.4109V18.586H16.8527V24.5272C21.159 24.0998 24.5272 20.4581 24.5272 16.0214Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_825_4401">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Google = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_825_4476)">
      <circle cx="16" cy="16" r="15.5" fill="white" stroke="#AAB7D5" />
      <g clipPath="url(#clip1_825_4476)">
        <path
          d="M19.7256 8.83623C19.8674 8.91097 20.0048 8.99406 20.1496 9.06265C20.1514 9.07012 20.1509 9.07892 20.1623 9.07892C20.2747 9.15102 20.3875 9.22136 20.4985 9.29522C20.5898 9.35633 20.6798 9.42008 20.7684 9.48471C20.987 9.6443 21.1972 9.81488 21.396 9.99865C21.4219 10.0224 21.4474 10.0466 21.4741 10.069C21.4904 10.0826 21.4943 10.0932 21.4754 10.1077C21.4632 10.1174 21.4531 10.1292 21.4421 10.1402C20.8351 10.7482 20.2295 11.3572 19.6207 11.9634C19.5014 12.0826 19.382 12.2017 19.2604 12.3191C19.242 12.3367 19.2332 12.3697 19.2064 12.3719C19.1806 12.3741 19.1731 12.3402 19.1533 12.3261C19.1244 12.3055 19.0985 12.28 19.0713 12.2567C19.0691 12.2567 19.0669 12.2567 19.0651 12.2567C19.0283 12.2136 18.9773 12.1863 18.9392 12.1446C18.9378 12.1358 18.9321 12.1318 18.9238 12.1318C18.8795 12.087 18.8229 12.0588 18.775 12.0188C18.7737 12.0091 18.7667 12.007 18.7583 12.0074C18.7377 12.0034 18.7285 11.9837 18.7123 11.974C18.7092 11.9722 18.7061 11.97 18.7035 11.9683C18.6908 11.9595 18.678 11.9511 18.6657 11.9423C18.6631 11.9406 18.6605 11.9392 18.6574 11.9375C18.6447 11.9287 18.6315 11.9195 18.6188 11.9107C18.6162 11.9093 18.6135 11.9076 18.6109 11.9063C18.6056 11.9028 18.6008 11.8992 18.5955 11.8953C18.5929 11.8935 18.5898 11.8918 18.5872 11.8904C18.481 11.8166 18.3695 11.7506 18.2532 11.6944C18.2475 11.6917 18.2427 11.6882 18.237 11.6847C18.2348 11.6829 18.2326 11.6812 18.2299 11.6794C18.1865 11.6557 18.1444 11.6306 18.0965 11.6157C18.0939 11.6135 18.0917 11.6113 18.0891 11.6091C18.0575 11.6025 18.0346 11.5757 18.0026 11.5704C17.9986 11.5647 18 11.5524 17.9872 11.5568C17.9741 11.5537 17.9613 11.5502 17.9482 11.5471C17.9447 11.5405 17.9455 11.5291 17.9324 11.5335C17.8806 11.5216 17.8341 11.4948 17.784 11.4776C17.6102 11.4178 17.4356 11.3598 17.2578 11.3119C17.2214 11.3022 17.181 11.2886 17.1472 11.2846C17.0959 11.2785 17.0463 11.2609 16.9949 11.26C16.9352 11.2587 16.8795 11.2376 16.8207 11.2327C16.7417 11.2266 16.6636 11.2112 16.5846 11.2046C16.3866 11.1879 16.1887 11.1813 15.9903 11.1892C15.8789 11.1936 15.767 11.1989 15.6559 11.2178C15.6182 11.2244 15.5787 11.22 15.5401 11.2204C15.5326 11.2191 15.5256 11.2195 15.5256 11.2301C15.5124 11.2297 15.4988 11.2292 15.4856 11.2283C15.4777 11.2275 15.4711 11.2283 15.4716 11.2389C15.3821 11.2543 15.2925 11.2683 15.2039 11.2859C15.1859 11.2895 15.1683 11.289 15.1508 11.2912C15.1389 11.289 15.1341 11.2987 15.1275 11.3053C15.0617 11.3189 14.995 11.3325 14.9304 11.3488C14.8308 11.3743 14.7338 11.4121 14.6364 11.4468C14.431 11.5198 14.2309 11.6064 14.0365 11.7045C14.0307 11.7071 14.0259 11.7111 14.0207 11.7141C14.0149 11.7111 14.0141 11.7141 14.0136 11.719C13.8512 11.8034 13.6985 11.9028 13.5453 12.0021C13.5396 11.9999 13.5379 12.0039 13.5366 12.0078C13.5137 12.0241 13.4905 12.0404 13.4677 12.0566C13.462 12.0544 13.4602 12.0584 13.4589 12.0623C13.4514 12.0681 13.444 12.0738 13.4365 12.0795C13.4308 12.0777 13.429 12.0817 13.4273 12.0856C13.3808 12.1217 13.3364 12.1604 13.2904 12.1969C13.2333 12.2413 13.1767 12.2861 13.1214 12.3332C12.9529 12.4761 12.7962 12.6312 12.6531 12.7988C12.6044 12.8559 12.5583 12.9161 12.51 12.9733C12.4051 13.0982 12.3125 13.2314 12.223 13.3668C12.1835 13.4261 12.1515 13.4912 12.1133 13.551C12.0167 13.7005 11.9404 13.8596 11.8662 14.0201C11.8039 14.1551 11.7495 14.2931 11.7016 14.4342C11.6968 14.4483 11.6955 14.4646 11.6827 14.4751C11.3316 14.2021 10.9805 13.9295 10.6294 13.6565C10.478 13.5387 10.3266 13.4213 10.1756 13.3035C10.0027 13.1694 9.83024 13.0348 9.65732 12.9007C9.57744 12.8388 9.49757 12.7772 9.41725 12.7152C9.2891 12.6163 9.16139 12.5174 9.03323 12.4189C9.03455 12.4141 9.03455 12.4083 9.03674 12.404C9.1548 12.1683 9.28383 11.9388 9.42384 11.7155C9.49669 11.5994 9.57349 11.486 9.65425 11.3747C9.77143 11.2134 9.89168 11.0542 10.0181 10.9004C10.1475 10.7421 10.2836 10.5895 10.4236 10.4405C10.5087 10.3499 10.597 10.2624 10.69 10.1789C10.7835 10.0949 10.8748 10.0088 10.9709 9.92743C11.1258 9.79642 11.282 9.66716 11.4462 9.54714C11.5827 9.44734 11.7214 9.35062 11.8627 9.25829C11.9544 9.19806 12.0466 9.13739 12.1444 9.08639C12.2603 9.02616 12.3713 8.95669 12.4881 8.8969C12.6325 8.82304 12.7782 8.75182 12.9265 8.68631C13.0617 8.62652 13.1973 8.56805 13.3364 8.51749C13.354 8.51837 13.3663 8.51001 13.3751 8.49551C13.444 8.48496 13.5067 8.45286 13.5721 8.43176C13.6511 8.40626 13.7288 8.37504 13.8109 8.35966C13.8232 8.36229 13.828 8.35262 13.8346 8.34559C13.8627 8.34119 13.8877 8.32053 13.9131 8.31789C13.9702 8.31174 14.0233 8.29195 14.0773 8.27656C14.2958 8.21501 14.5183 8.17149 14.7409 8.12796C14.8519 8.10642 14.9651 8.09367 15.0775 8.07872C15.2008 8.06246 15.3228 8.03916 15.4479 8.03959C15.4532 8.04091 15.4553 8.03784 15.4562 8.03344C15.5756 8.02509 15.6945 8.01673 15.8139 8.00838C15.8244 8.00838 15.8345 8.0075 15.8451 8.00706C15.885 8.00662 15.9249 8.00618 15.9644 8.00574C16.0184 8.01058 16.072 8.01629 16.1255 8.00179H16.1799C16.1874 8.01146 16.1984 8.00926 16.2085 8.00926C16.3024 8.00926 16.3967 8.00926 16.4907 8.0097C16.5885 8.01322 16.686 8.02377 16.7834 8.0308C16.8391 8.03476 16.8953 8.04619 16.9519 8.03959C16.9537 8.04883 16.9607 8.04795 16.9673 8.04663C17.0801 8.05806 17.1924 8.06949 17.3048 8.08488C17.4281 8.10158 17.551 8.11917 17.6726 8.14335C17.7485 8.1583 17.8249 8.17545 17.9003 8.19303C17.996 8.21501 18.0913 8.23963 18.1878 8.2581C18.2607 8.27217 18.3309 8.29283 18.4002 8.31745C18.4072 8.32009 18.4121 8.31921 18.4182 8.31745C18.4182 8.32756 18.4235 8.32976 18.4323 8.32844C18.4546 8.328 18.4731 8.34647 18.4963 8.34119C18.4963 8.3513 18.502 8.35306 18.5104 8.35174C18.5543 8.36273 18.5977 8.37548 18.6416 8.38779C18.7114 8.40758 18.7772 8.44099 18.847 8.45726C18.8874 8.46649 18.9203 8.48671 18.9576 8.49858C19.0362 8.52408 19.109 8.56409 19.1889 8.58651C19.1915 8.59399 19.1972 8.59531 19.2042 8.59487C19.3337 8.65378 19.4627 8.71269 19.5922 8.77204C19.6168 8.78347 19.6401 8.79666 19.6638 8.80941C19.6787 8.81777 19.6936 8.82436 19.7112 8.82128C19.7151 8.82788 19.7151 8.83799 19.727 8.83667L19.7256 8.83623Z"
          fill="#E8352C"
        />
        <path
          d="M9.03281 12.4175C9.16097 12.5165 9.28868 12.6154 9.41683 12.7139C9.49671 12.7759 9.57702 12.8374 9.6569 12.8994C9.82982 13.0335 10.0023 13.168 10.1752 13.3021C10.3266 13.4199 10.478 13.5373 10.629 13.6551C10.9801 13.9282 11.3312 14.2007 11.6823 14.4738C11.6845 14.4927 11.6753 14.5089 11.67 14.5261C11.627 14.6659 11.5818 14.8057 11.5542 14.9495C11.541 15.0194 11.5177 15.0875 11.5134 15.1609C11.5107 15.2071 11.491 15.2572 11.487 15.3056C11.4818 15.3715 11.4633 15.4344 11.4567 15.4995C11.4282 15.7984 11.4212 16.0974 11.4497 16.3968C11.4594 16.501 11.4708 16.6056 11.4879 16.7089C11.5169 16.8843 11.552 17.0589 11.5994 17.2308C11.6231 17.3161 11.6498 17.4005 11.6762 17.4849C11.6801 17.4976 11.6845 17.5095 11.6797 17.5227C11.6762 17.5249 11.6727 17.5262 11.6696 17.5289C10.9801 18.0657 10.2906 18.6025 9.60072 19.1388C9.412 19.2857 9.22285 19.4308 9.03369 19.5767C8.992 19.5139 8.96347 19.4444 8.93143 19.3762C8.63607 18.7497 8.42584 18.0951 8.3012 17.4137C8.25819 17.1785 8.22703 16.9415 8.20553 16.7032C8.1928 16.5625 8.1849 16.4214 8.18051 16.2798C8.18051 16.2684 8.18314 16.2561 8.1748 16.246V15.8947C8.18665 15.8846 8.18227 15.871 8.18227 15.8586C8.1827 15.7984 8.1827 15.7382 8.18314 15.6784C8.1849 15.5487 8.19412 15.4194 8.20597 15.2902C8.22747 15.0506 8.25907 14.8127 8.30208 14.5762C8.41882 13.9387 8.61017 13.3245 8.87701 12.7345C8.92573 12.6273 8.97181 12.5187 9.03237 12.4175H9.03281Z"
          fill="#FBBC05"
        />
        <path
          d="M9.03284 12.4176C8.97228 12.5192 8.92576 12.6273 8.87748 12.7346C8.6102 13.3246 8.41885 13.9388 8.30255 14.5763C8.2591 14.8128 8.22794 15.0506 8.20644 15.2903C8.19502 15.4195 8.18537 15.5488 8.18361 15.6785C8.18098 15.6776 8.17791 15.6771 8.17528 15.6763C8.17528 13.1294 8.17528 10.583 8.1744 8.03611C8.17396 8.00666 8.18054 8.00006 8.20995 8.00006C10.7445 8.00094 13.279 8.00094 15.8131 8.00094C15.8131 8.00314 15.8131 8.00534 15.8131 8.00753C15.6937 8.01589 15.5748 8.02424 15.4554 8.03259C15.4528 8.03479 15.4497 8.03699 15.4471 8.03875C15.322 8.03831 15.2 8.06161 15.0766 8.07788C14.9643 8.09283 14.8511 8.10514 14.74 8.12712C14.5175 8.17064 14.295 8.21417 14.0764 8.27572C14.0225 8.29111 13.9698 8.31045 13.9123 8.31705C13.8873 8.31968 13.8623 8.34035 13.8337 8.34474C13.8228 8.3443 13.8118 8.34386 13.81 8.35881C13.728 8.37464 13.6503 8.40541 13.5713 8.43091C13.5055 8.45202 13.4431 8.48411 13.3742 8.49466C13.3532 8.48675 13.344 8.50082 13.3356 8.51664C13.1965 8.5672 13.0609 8.62568 12.9257 8.68547C12.7774 8.75141 12.6316 8.8222 12.4873 8.89606C12.3705 8.95585 12.2595 9.02487 12.1436 9.08554C12.0457 9.13654 11.9536 9.19765 11.8619 9.25745C11.7205 9.34977 11.5819 9.44649 11.4454 9.54629C11.2812 9.66632 11.125 9.79557 10.9701 9.92659C10.8739 10.0079 10.7827 10.0941 10.6892 10.1781C10.5966 10.2616 10.5079 10.3491 10.4228 10.4397C10.2828 10.5887 10.1467 10.7412 10.0172 10.8995C9.89085 11.0538 9.7706 11.2125 9.65342 11.3739C9.57267 11.4851 9.49586 11.5986 9.42301 11.7146C9.28301 11.938 9.15354 12.1675 9.03592 12.4031C9.03372 12.4075 9.03328 12.4128 9.03241 12.4181L9.03284 12.4176Z"
          fill="white"
        />
        <path
          d="M16.4902 8.00897C16.3963 8.00897 16.302 8.00897 16.208 8.00852C16.1979 8.00852 16.187 8.01077 16.1795 8.00089C16.2835 8.00089 16.3875 8.00089 16.4911 8.00089C16.4902 8.00268 16.4889 8.00448 16.4885 8.00628C16.4885 8.00717 16.4894 8.00807 16.4902 8.00942V8.00897Z"
          fill="#EA513B"
        />
        <path
          d="M8.1748 15.6758C8.17744 15.6766 8.18051 15.6771 8.18314 15.6779C8.18314 15.7382 8.18314 15.7984 8.18227 15.8582C8.18227 15.8705 8.18665 15.8841 8.1748 15.8943C8.1748 15.8213 8.1748 15.7483 8.1748 15.6758Z"
          fill="#F8B200"
        />
        <path
          d="M16.1247 8.00088C16.0711 8.0157 16.0176 8.00941 15.9636 8.00492C15.964 8.00178 15.9658 8.00043 15.9689 8.00088H16.1247Z"
          fill="#EA513B"
        />
        <path
          d="M15.9688 8.00088C15.9658 8.00043 15.964 8.00178 15.9636 8.00492C15.9236 8.00537 15.8837 8.00582 15.8442 8.00627C15.8442 8.00447 15.8442 8.00267 15.8442 8.00088H15.9688Z"
          fill="#FEF5F1"
        />
        <path
          d="M15.8449 8.00089C15.8449 8.00089 15.8449 8.00456 15.8449 8.0064C15.8341 8.0064 15.8238 8.00731 15.813 8.00777C15.813 8.00548 15.813 8.00318 15.813 8.00089H15.8449Z"
          fill="#FFF9F7"
        />
        <path
          d="M9.03369 19.5763C9.22285 19.4303 9.41244 19.2852 9.60072 19.1384C10.2906 18.602 10.9801 18.0652 11.6696 17.5284C11.6727 17.5262 11.6762 17.5244 11.6797 17.5222C11.692 17.5315 11.6937 17.5464 11.6986 17.5596C11.9097 18.1734 12.2314 18.7234 12.6588 19.2105C12.8699 19.4514 13.1043 19.6682 13.3593 19.862C13.8653 20.2467 14.4253 20.5193 15.0411 20.6767C15.2034 20.718 15.3676 20.7492 15.5335 20.7725C15.77 20.806 16.0084 20.8161 16.2471 20.8147C16.3454 20.8143 16.4442 20.8121 16.542 20.8046C17.2491 20.7497 17.9236 20.5787 18.5468 20.2287C18.6478 20.172 18.7478 20.114 18.8418 20.0462C18.901 20.0911 18.9581 20.1381 19.0191 20.1808C19.0691 20.2155 19.1099 20.263 19.1604 20.2968C19.285 20.3808 19.3996 20.4784 19.5181 20.5703C19.5839 20.6213 19.6532 20.6675 19.7156 20.722C19.7981 20.7941 19.8916 20.8517 19.9736 20.9247C20.057 20.999 20.1509 21.0605 20.2391 21.1287C20.3252 21.195 20.4125 21.2592 20.4954 21.3305C20.5784 21.4017 20.6671 21.4659 20.7557 21.5301C20.8215 21.5775 20.8825 21.632 20.9466 21.6817C21.1086 21.8066 21.2709 21.931 21.4333 22.0554C21.4232 22.0717 21.4088 22.084 21.3943 22.0959C21.3886 22.0946 21.3868 22.0981 21.3851 22.1025C21.3561 22.1315 21.3262 22.1592 21.2933 22.1829C21.2793 22.1829 21.2696 22.1878 21.2718 22.204C21.2688 22.2071 21.2652 22.2102 21.2622 22.2133C21.2565 22.2115 21.2547 22.2155 21.253 22.2194C21.2481 22.2229 21.2437 22.226 21.2389 22.2295C21.2249 22.2295 21.2152 22.2344 21.2174 22.2506L21.2078 22.2599C21.2025 22.2581 21.2003 22.2616 21.199 22.266C21.1941 22.2695 21.1893 22.2731 21.1845 22.2766C21.1691 22.2753 21.1617 22.2827 21.1603 22.2977C21.1555 22.3012 21.1507 22.3047 21.1459 22.3082C21.1367 22.3082 21.1301 22.3104 21.1323 22.3219C21.1213 22.3302 21.1099 22.3386 21.0989 22.3469C21.0879 22.3452 21.0835 22.35 21.0835 22.3605C21.0787 22.3605 21.0761 22.3627 21.077 22.368C21.0585 22.3882 21.0348 22.4019 21.0133 22.4177C21.0081 22.4155 21.0067 22.4177 21.0076 22.423C20.9655 22.4551 20.9229 22.4872 20.8808 22.5193C20.8751 22.5166 20.8742 22.5193 20.8751 22.5241C20.7539 22.6173 20.6293 22.7052 20.499 22.7848C20.4933 22.7817 20.4924 22.7861 20.4906 22.7896C20.47 22.8143 20.4344 22.8151 20.4129 22.8393C20.4077 22.8362 20.4064 22.8402 20.4046 22.8442C20.3954 22.8604 20.3691 22.842 20.3638 22.8648L20.3629 22.8661C20.3072 22.9127 20.2418 22.9439 20.179 22.9796C20.1733 22.9765 20.172 22.9809 20.1702 22.9848C20.1268 23.0103 20.0776 23.0248 20.0386 23.0578C20.0329 23.0547 20.032 23.0578 20.0316 23.0627C19.9899 23.0842 19.9477 23.1062 19.906 23.1277C19.9003 23.1246 19.899 23.129 19.8973 23.133C19.838 23.1743 19.7691 23.1963 19.7055 23.228C19.5878 23.286 19.4663 23.3357 19.3456 23.3867C19.2385 23.432 19.1323 23.4786 19.0213 23.5146C19.0151 23.5164 19.0085 23.5159 19.0019 23.5168C18.9932 23.5168 18.9844 23.515 18.9782 23.5234C18.905 23.563 18.8264 23.588 18.7448 23.603C18.7334 23.6017 18.7233 23.603 18.7211 23.617C18.6934 23.6144 18.6719 23.6399 18.6434 23.6338C18.632 23.6324 18.6214 23.6329 18.6197 23.6478C18.4362 23.7019 18.2506 23.7498 18.0641 23.7925C17.9179 23.8259 17.7691 23.8483 17.6212 23.8747C17.3526 23.9222 17.0819 23.9494 16.8102 23.9683C16.4955 23.9907 16.1808 23.9951 15.8653 23.9868C15.706 23.9824 15.5475 23.9657 15.3882 23.9582C15.307 23.9543 15.225 23.9397 15.1438 23.9301C15.0419 23.9182 14.9419 23.8953 14.8387 23.8883C14.7773 23.8839 14.718 23.8597 14.6566 23.8509C14.5587 23.8369 14.4613 23.8162 14.3661 23.7925C14.2581 23.7661 14.1506 23.7366 14.0431 23.7081C13.8934 23.6685 13.7468 23.6197 13.6002 23.5704C13.5287 23.5463 13.4585 23.5181 13.3869 23.4939C13.2798 23.4583 13.1785 23.4082 13.0727 23.3686C12.873 23.2939 12.6834 23.1967 12.4947 23.0996C12.324 23.0117 12.1563 22.9171 11.9931 22.8156C11.8759 22.7426 11.7618 22.6643 11.6463 22.5883C11.4703 22.4718 11.3023 22.3425 11.1386 22.208C11.0451 22.1315 10.952 22.055 10.8647 21.971C10.7809 21.891 10.697 21.8105 10.6097 21.7345C10.5118 21.6488 10.4298 21.549 10.338 21.4579C10.2547 21.3753 10.1796 21.2834 10.101 21.1959C10.0602 21.1506 10.0273 21.0957 9.98518 21.0508C9.87678 20.9352 9.79515 20.7994 9.69333 20.6785C9.62311 20.5949 9.57044 20.496 9.50987 20.4041C9.48091 20.3602 9.44536 20.3201 9.41771 20.2766C9.3905 20.2331 9.36548 20.1874 9.33915 20.143C9.23733 19.9715 9.14341 19.7957 9.05169 19.6185C9.04466 19.6048 9.03325 19.593 9.03457 19.5763H9.03369Z"
          fill="#34A853"
        />
        <path
          d="M21.4329 22.055C21.2705 21.9306 21.1081 21.8066 20.9462 21.6813C20.8817 21.6316 20.8211 21.5771 20.7553 21.5296C20.6666 21.4654 20.578 21.4012 20.495 21.33C20.4125 21.2592 20.3247 21.1946 20.2387 21.1282C20.1505 21.0601 20.0566 20.9985 19.9732 20.9242C19.8911 20.8512 19.7976 20.7936 19.7151 20.7215C19.6528 20.667 19.583 20.6209 19.5176 20.5699C19.3991 20.478 19.2846 20.3804 19.1599 20.2964C19.1095 20.2626 19.0686 20.2151 19.0186 20.1803C18.9576 20.1377 18.9006 20.0907 18.8413 20.0458C18.9243 19.9869 19.0094 19.9315 19.0897 19.8691C19.2302 19.7609 19.3539 19.6352 19.4794 19.5112C19.7682 19.2254 19.9899 18.8931 20.1632 18.5277C20.2843 18.2723 20.3721 18.0054 20.4318 17.7289C20.4366 17.7073 20.4322 17.6854 20.4419 17.6643C20.4458 17.655 20.4428 17.6458 20.4279 17.6423C20.4085 17.6379 20.3892 17.6374 20.3699 17.6374C18.9831 17.6374 17.5958 17.6374 16.2089 17.6374C16.1466 17.6374 16.1554 17.6454 16.1554 17.5838C16.1554 16.595 16.1554 15.6063 16.1554 14.6175C16.1554 14.6008 16.1545 14.5837 16.1541 14.567C16.1549 14.5595 16.1554 14.5516 16.1562 14.5441C16.1589 14.5432 16.1615 14.5423 16.1641 14.5415C16.1795 14.5415 16.1953 14.5423 16.2107 14.5423C18.6785 14.5423 21.1467 14.5423 23.6146 14.5423C23.6299 14.5423 23.6457 14.5415 23.6611 14.5415C23.6637 14.5415 23.6668 14.5419 23.6694 14.5423C23.6826 14.5568 23.6808 14.5727 23.683 14.5916C23.6887 14.6461 23.687 14.7032 23.7168 14.7547C23.7278 14.7732 23.7295 14.8044 23.7247 14.8242C23.7146 14.8694 23.7282 14.9116 23.7352 14.953C23.7418 14.993 23.7405 15.0334 23.7489 15.0717C23.7589 15.1192 23.7546 15.168 23.7642 15.2141C23.7853 15.3126 23.7844 15.4124 23.7919 15.5118C23.8103 15.7659 23.8199 16.0204 23.8164 16.2754C23.8107 16.6671 23.7853 17.0571 23.7335 17.4453C23.6312 18.2147 23.4337 18.9573 23.1239 19.669C23.0256 19.8955 22.915 20.1157 22.7947 20.3311C22.6376 20.6121 22.4616 20.8807 22.2676 21.1379C22.1307 21.3195 21.985 21.494 21.8305 21.6611C21.712 21.789 21.5869 21.9099 21.4636 22.0326C21.4548 22.0414 21.4469 22.0532 21.4324 22.0546L21.4329 22.055Z"
          fill="#4285F4"
        />
        <path
          d="M16.1566 14.5447C16.1557 14.5524 16.1553 14.5604 16.1544 14.5681C16.1337 14.5613 16.1373 14.5492 16.1476 14.5362C16.1508 14.5389 16.1535 14.542 16.1566 14.5447Z"
          fill="#FAFBFD"
        />
        <path
          d="M21.159 22.2977C21.1604 22.2824 21.1684 22.2748 21.1837 22.2761C21.1824 22.2914 21.1734 22.2977 21.159 22.2977Z"
          fill="#F4F9F3"
        />
        <path
          d="M21.2165 22.2511C21.2143 22.234 21.2242 22.2295 21.2385 22.2295C21.2376 22.2435 21.23 22.2502 21.2165 22.2511Z"
          fill="#F4F9F3"
        />
        <path
          d="M21.2709 22.2041C21.2687 22.187 21.2786 22.1825 21.2929 22.1825C21.292 22.1964 21.2844 22.2032 21.2709 22.2041Z"
          fill="#F4F9F3"
        />
        <path
          d="M18.6188 23.6485C18.6206 23.6329 18.6314 23.6324 18.643 23.6338C18.6412 23.6499 18.6305 23.6494 18.6188 23.6485Z"
          fill="#F4F9F3"
        />
        <path
          d="M18.7202 23.6173C18.7224 23.6021 18.7327 23.6012 18.7444 23.6026C18.7426 23.6186 18.7318 23.6182 18.7202 23.6173Z"
          fill="#F4F9F3"
        />
        <path
          d="M15.1271 11.3041C15.1338 11.2972 15.1387 11.2871 15.1509 11.2894C15.1495 11.3055 15.1378 11.3046 15.1271 11.3041Z"
          fill="#FEF5F1"
        />
        <path
          d="M18.9774 23.5233C18.9836 23.5145 18.9926 23.5159 19.0016 23.5164C18.9984 23.537 18.9872 23.5279 18.9774 23.5233Z"
          fill="#F4F9F3"
        />
        <path
          d="M17.9877 11.5554C18.0009 11.5513 17.9995 11.5638 18.0036 11.5698C17.9941 11.5698 17.9886 11.5652 17.9877 11.5554Z"
          fill="#FEF5F1"
        />
        <path
          d="M15.4716 11.2381C15.4711 11.227 15.4779 11.2261 15.4861 11.227C15.4847 11.2354 15.4843 11.2451 15.4716 11.2381Z"
          fill="#FEF5F1"
        />
        <path
          d="M17.9328 11.5317C17.9458 11.5276 17.9454 11.539 17.949 11.5459C17.9391 11.5459 17.9337 11.5413 17.9328 11.5317Z"
          fill="#FEF5F1"
        />
        <path
          d="M21.0822 22.3605C21.0822 22.3493 21.0872 22.3442 21.0981 22.3461C21.0981 22.3567 21.0917 22.3609 21.0822 22.3605Z"
          fill="#F4F9F3"
        />
        <path
          d="M21.1309 22.3222C21.1282 22.3101 21.135 22.3073 21.145 22.3078C21.145 22.3171 21.14 22.3217 21.1309 22.3222Z"
          fill="#F4F9F3"
        />
        <path
          d="M16.9674 8.04683C16.9606 8.04823 16.9533 8.04916 16.9515 8.0394C16.9633 8.02779 16.9656 8.03708 16.9674 8.04683Z"
          fill="#FFF9F7"
        />
        <path
          d="M18.4323 8.32782C18.4237 8.32922 18.4178 8.32689 18.4178 8.31621C18.4305 8.3097 18.4305 8.31946 18.4323 8.32782Z"
          fill="#FEF5F1"
        />
        <path
          d="M18.5104 8.35154C18.5018 8.35294 18.4959 8.35061 18.4959 8.34039C18.5086 8.33342 18.5086 8.34364 18.5104 8.35154Z"
          fill="#FEF5F1"
        />
        <path
          d="M18.7584 12.0065C18.7669 12.0065 18.7736 12.0083 18.7754 12.0184C18.7624 12.0253 18.7597 12.0166 18.7584 12.0065Z"
          fill="#E94433"
        />
        <path
          d="M20.1626 9.07879C20.1514 9.07879 20.1514 9.0698 20.1496 9.06216C20.1595 9.06351 20.1622 9.0698 20.1626 9.07879Z"
          fill="#FEF5F1"
        />
        <path
          d="M15.526 11.2293C15.526 11.2182 15.5333 11.2182 15.541 11.2191C15.5397 11.2279 15.5387 11.2377 15.526 11.2293Z"
          fill="#FEF5F1"
        />
        <path
          d="M18.9238 12.1309C18.9328 12.1309 18.9382 12.135 18.9395 12.1442C18.9274 12.1483 18.9211 12.1451 18.9238 12.1309Z"
          fill="#E94433"
        />
        <path
          d="M19.2039 8.59469C19.1966 8.59469 19.1907 8.59376 19.188 8.58586C19.2012 8.57425 19.2021 8.58493 19.2039 8.59469Z"
          fill="#FEF5F1"
        />
        <path
          d="M19.726 8.83687C19.7139 8.83825 19.7139 8.82769 19.7098 8.8208C19.7206 8.8208 19.7251 8.82677 19.726 8.83687Z"
          fill="#FEF5F1"
        />
        <path
          d="M16.1564 14.5452C16.1533 14.5424 16.1506 14.5392 16.1475 14.5365C16.1582 14.5241 16.1618 14.5314 16.1645 14.5424C16.1618 14.5434 16.1591 14.5443 16.1564 14.5452Z"
          fill="#DDE3F3"
        />
        <path
          d="M23.6702 14.5433C23.6674 14.5433 23.6643 14.5429 23.6615 14.5424C23.6633 14.5392 23.6647 14.5364 23.6665 14.5331C23.6679 14.5364 23.6692 14.5401 23.6702 14.5433Z"
          fill="#DDE3F3"
        />
        <path
          d="M19.0651 12.2558C19.0651 12.2558 19.0697 12.2558 19.0715 12.2558C19.0697 12.2576 19.0678 12.2595 19.066 12.2613C19.066 12.2595 19.0656 12.2576 19.0651 12.2558Z"
          fill="#E94433"
        />
        <path
          d="M13.4264 12.0847C13.4282 12.0805 13.4301 12.0763 13.436 12.0782C13.4328 12.0805 13.4296 12.0823 13.4264 12.0847Z"
          fill="#FFF9F7"
        />
        <path
          d="M13.5357 12.0068C13.5375 12.0026 13.5393 11.9985 13.5448 12.0008C13.5416 12.0026 13.5384 12.005 13.5357 12.0068Z"
          fill="#FFF9F7"
        />
        <path
          d="M18.7035 11.9673C18.7067 11.9692 18.7098 11.9715 18.7126 11.9734C18.7067 11.9757 18.7049 11.9715 18.7035 11.9673Z"
          fill="#E94433"
        />
        <path
          d="M21.3846 22.1024C21.3864 22.0982 21.3882 22.0941 21.3941 22.0955C21.391 22.0978 21.3878 22.1001 21.3846 22.1024Z"
          fill="#F9FCF9"
        />
        <path
          d="M18.6574 11.9361C18.6601 11.938 18.6629 11.9394 18.666 11.9412C18.6606 11.944 18.6592 11.9403 18.6574 11.9361Z"
          fill="#E94433"
        />
        <path
          d="M21.2521 22.2194C21.2539 22.2147 21.2557 22.211 21.2616 22.2129C21.2584 22.2152 21.2553 22.2175 21.2521 22.2194Z"
          fill="#F4F9F3"
        />
        <path
          d="M21.1981 22.266C21.1995 22.2613 21.2017 22.2581 21.2072 22.2595C21.204 22.2618 21.2013 22.2636 21.1981 22.266Z"
          fill="#F4F9F3"
        />
        <path
          d="M18.6104 11.9049C18.6132 11.9063 18.6159 11.9082 18.6186 11.9096C18.6132 11.9133 18.6118 11.9086 18.6104 11.9049Z"
          fill="#E94433"
        />
        <path
          d="M18.5868 11.8891C18.5895 11.8909 18.5927 11.8928 18.5954 11.8942C18.5895 11.897 18.5881 11.8928 18.5868 11.8891Z"
          fill="#E94433"
        />
        <path
          d="M14.0132 11.7175C14.0132 11.7129 14.0145 11.7092 14.0204 11.7124L14.0132 11.7175Z"
          fill="#FFF9F7"
        />
        <path
          d="M21.0756 22.3676C21.0747 22.362 21.0775 22.3597 21.0825 22.3597C21.0802 22.3625 21.0779 22.3648 21.0756 22.3676Z"
          fill="#F4F9F3"
        />
        <path
          d="M21.0059 22.4224C21.0049 22.4173 21.0059 22.4146 21.0118 22.4169C21.0099 22.4187 21.0077 22.4206 21.0059 22.4224Z"
          fill="#F4F9F3"
        />
        <path
          d="M20.8733 22.524C20.8724 22.5184 20.8733 22.5156 20.8792 22.5189L20.8733 22.524Z"
          fill="#F9FCF9"
        />
        <path
          d="M20.4889 22.7895C20.4902 22.7858 20.4916 22.7812 20.4975 22.7844C20.4948 22.7863 20.492 22.7877 20.4889 22.7895Z"
          fill="#F9FCF9"
        />
        <path
          d="M20.4033 22.8436C20.4047 22.8394 20.406 22.8353 20.4119 22.8385C20.4092 22.8404 20.4065 22.8418 20.4033 22.8436Z"
          fill="#F9FCF9"
        />
        <path
          d="M20.3621 22.8644C20.3621 22.8644 20.3657 22.8667 20.368 22.8681C20.3639 22.8741 20.3634 22.8662 20.3611 22.8658L20.3621 22.8644Z"
          fill="#F9FCF9"
        />
        <path
          d="M20.1689 22.9848C20.1707 22.9806 20.1721 22.9759 20.178 22.9792C20.1748 22.981 20.1721 22.9829 20.1689 22.9848Z"
          fill="#F9FCF9"
        />
        <path
          d="M20.0302 23.0626C20.0302 23.0579 20.0311 23.0537 20.0375 23.0575C20.0352 23.0593 20.0329 23.0607 20.0302 23.0626Z"
          fill="#F9FCF9"
        />
        <path
          d="M19.8959 23.1329C19.8978 23.1287 19.8991 23.1241 19.905 23.1273C19.9018 23.1292 19.8991 23.1311 19.8959 23.1329Z"
          fill="#F9FCF9"
        />
        <path
          d="M18.2299 11.6785C18.2322 11.6804 18.2345 11.6822 18.2372 11.6841C18.2313 11.6873 18.2304 11.6836 18.2299 11.6785Z"
          fill="#E94433"
        />
        <path
          d="M18.0895 11.6077C18.0922 11.61 18.0945 11.6124 18.0972 11.6147C18.0918 11.6156 18.0895 11.6128 18.0895 11.6077Z"
          fill="#E94433"
        />
        <path
          d="M13.458 12.0613C13.4599 12.0572 13.4612 12.053 13.4671 12.0553C13.4639 12.0572 13.4608 12.0595 13.458 12.0613Z"
          fill="#FFF9F7"
        />
        <path
          d="M13.3351 8.51666C13.3437 8.50093 13.3526 8.48655 13.3746 8.49419C13.3657 8.50902 13.3531 8.51711 13.3351 8.51666Z"
          fill="#EA513B"
        />
        <path
          d="M13.81 8.35938C13.8118 8.34331 13.823 8.34377 13.8342 8.34468C13.8279 8.35249 13.8226 8.36213 13.81 8.35938Z"
          fill="#FEF5F1"
        />
        <path
          d="M15.4466 8.03902C15.4493 8.0367 15.4525 8.03437 15.4552 8.03252C15.4543 8.03716 15.452 8.04041 15.4466 8.03902Z"
          fill="#FFF9F7"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_825_4476">
        <rect width="32" height="32" fill="white" />
      </clipPath>
      <clipPath id="clip1_825_4476">
        <rect
          width="15.6522"
          height="16"
          fill="white"
          transform="translate(8.17389 8)"
        />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Twitter = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_825_4475)">
      <circle cx="16" cy="16" r="16" fill="#4AA1EB" />
      <path
        d="M23.9711 10.824C23.3289 11.1139 22.236 11.6577 21.6868 11.7616C21.6655 11.7669 21.6482 11.7737 21.6277 11.7789C20.9871 11.1749 20.1093 10.8006 19.1377 10.8006C17.1797 10.8006 15.5919 12.3182 15.5919 14.1898C15.5919 14.2884 15.5832 14.4699 15.5919 14.5664C13.0563 14.5664 11.2045 13.3018 9.81852 11.6765C9.63335 11.4581 9.43635 11.5718 9.39538 11.727C9.30319 12.0779 9.27167 12.6646 9.27167 13.0834C9.27167 14.1386 10.1345 15.1749 11.478 15.8173C11.2305 15.8783 10.9579 15.922 10.6742 15.922C10.3401 15.922 9.95562 15.8384 9.61916 15.6697C9.49466 15.6072 9.22597 15.6245 9.30555 15.9288C9.62468 17.1481 11.0808 18.0045 12.3818 18.2538C12.0863 18.4202 11.4559 18.3863 11.1659 18.3863C11.0588 18.3863 10.6861 18.3622 10.4449 18.3336C10.2251 18.308 9.88707 18.3622 10.1699 18.7719C10.7775 19.6509 12.1517 20.2029 13.3344 20.224C12.2454 21.0404 10.4646 21.3387 8.75871 21.3387C8.41358 21.3311 8.43092 21.707 8.70907 21.8463C9.96744 22.4774 12.0288 22.851 13.5015 22.851C19.356 22.851 22.6836 18.5859 22.6836 14.5656C22.6836 14.5008 22.682 14.3653 22.6796 14.2289C22.6796 14.2154 22.6836 14.2026 22.6836 14.189C22.6836 14.1687 22.6773 14.1491 22.6773 14.1288C22.6749 14.0263 22.6725 13.9307 22.6702 13.881C23.1343 13.5609 23.845 13.0051 24.2043 12.5795C24.3265 12.4349 24.228 12.2595 24.0617 12.3144C23.6339 12.4568 22.894 12.7324 22.4306 12.7852C23.3581 12.1984 23.8167 11.6878 24.2107 11.1207C24.3454 10.9271 24.1768 10.7306 23.9711 10.824Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_825_4475">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const LINE = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_825_4478)">
      <circle cx="16" cy="16" r="16" fill="#06C755" />
      <g clipPath="url(#clip1_825_4478)">
        <path
          d="M25.2088 15.3251C25.1281 16.1802 24.8958 16.9861 24.5026 17.7562C23.9703 18.7976 23.2083 19.6494 22.3705 20.4379C21.5885 21.1739 20.741 21.8346 19.8767 22.4736C18.857 23.2269 17.7787 23.8898 16.6935 24.5402C16.3674 24.7357 16.0301 24.9295 15.6483 25.0254C15.5064 25.0611 15.3905 25.0963 15.2833 24.9826C15.1625 24.8548 15.1062 24.7189 15.1495 24.5245C15.234 24.1465 15.3103 23.762 15.3385 23.3764C15.3872 22.7108 15.2091 22.518 14.5083 22.3583C14.1476 22.2759 13.7723 22.2781 13.4198 22.146C12.9492 21.9689 12.4591 21.8514 11.9825 21.6862C11.024 21.3542 10.1851 20.8414 9.41446 20.224C8.41692 19.4252 7.65117 18.4277 7.17406 17.2227C6.82151 16.333 6.6715 15.4085 6.74515 14.4624C6.82314 13.4562 7.15402 12.5177 7.67662 11.6518C8.18189 10.8145 8.84908 10.117 9.60888 9.51536C9.90944 9.27708 10.2522 9.08321 10.588 8.88554C11.0196 8.63101 11.4572 8.39327 11.9208 8.21022C12.608 7.93837 13.3158 7.73637 14.0518 7.63131C14.4991 7.5674 14.9442 7.49375 15.3954 7.46451C15.7761 7.46451 16.1568 7.46451 16.5369 7.46451C17.86 7.56036 19.1548 7.80244 20.3663 8.35265C20.969 8.62668 21.5382 8.97544 22.0944 9.34965C22.9105 9.89878 23.5825 10.5866 24.1263 11.381C24.5855 12.0515 24.8909 12.8167 25.0929 13.616C25.1682 13.9133 25.1763 14.2106 25.2072 14.509C25.2072 14.7814 25.2077 15.0538 25.2083 15.3262L25.2088 15.3251ZM14.2668 17.1686C14.3431 17.1177 14.3139 17.0386 14.3144 16.9709C14.316 15.728 14.316 14.4852 14.3144 13.2423C14.3144 13.1741 14.3388 13.0956 14.2657 13.0436C14.2148 12.9672 14.1222 12.9223 14.0642 12.9342C13.8698 12.9737 13.6906 12.9353 13.5064 12.9369C13.3651 12.9385 13.2866 12.9748 13.2871 13.1329C13.2893 14.4624 13.2887 15.7925 13.2871 17.122C13.2871 17.2482 13.3239 17.3283 13.4707 17.3245C13.677 17.3191 13.8839 17.3235 14.0908 17.324C14.1958 17.324 14.2597 17.278 14.2668 17.1675V17.1686ZM9.77676 17.2184C9.81034 17.3581 9.92514 17.3235 10.0167 17.324C10.8257 17.3262 11.6343 17.3251 12.4434 17.3262C12.5435 17.3262 12.6437 17.3348 12.6973 17.2233C12.7829 16.9492 12.7835 16.6747 12.6963 16.4007C12.6437 16.3075 12.5511 16.3725 12.4818 16.346C12.4119 16.2582 12.315 16.2999 12.2311 16.2988C11.7545 16.2923 11.2779 16.2923 10.8019 16.2902C10.8003 15.2856 10.7949 14.281 10.8003 13.2764C10.8014 13.1145 10.771 12.9715 10.6032 12.9569C10.3616 12.9353 10.1125 12.8909 9.8737 12.9894C9.78001 13.0382 9.76701 13.121 9.76755 13.2169C9.77243 14.5507 9.77513 15.884 9.77784 17.2179L9.77676 17.2184ZM22.2265 15.5986C22.3256 15.5537 22.3332 15.4692 22.3299 15.375C22.3251 15.2406 22.3288 15.1058 22.3288 14.9715C22.3288 14.6525 22.2991 14.6227 21.9714 14.6222C21.6487 14.6211 21.3259 14.6222 21.0031 14.6222C20.58 14.6222 20.3737 14.4065 20.3841 13.975C20.7887 13.9723 21.1932 13.9772 21.5972 13.9642C21.809 13.9577 22.0261 14.0173 22.2319 13.9231C22.4539 13.7173 22.2839 13.4579 22.3261 13.2272C22.364 13.0203 22.2557 12.9363 22.0554 12.9369C21.2484 12.9391 20.4415 12.938 19.6341 12.938C19.5198 12.938 19.4148 12.9499 19.3996 13.0961C19.392 13.1216 19.3779 13.1476 19.3779 13.173C19.3768 14.4781 19.3768 15.7833 19.3779 17.0884C19.3779 17.1133 19.3942 17.1382 19.4028 17.1637C19.4034 17.3402 19.529 17.3262 19.6476 17.3262C20.3858 17.3256 21.1239 17.3262 21.862 17.3262C22.0671 17.3262 22.212 17.2505 22.2969 17.0993C22.3733 16.9633 22.3251 16.4694 22.2232 16.3481C22.1534 16.2631 22.0575 16.3005 21.973 16.2999C21.5355 16.2961 21.0979 16.2978 20.6609 16.2983C20.5639 16.2983 20.4643 16.3113 20.3841 16.2371C20.3841 16.0432 20.3841 15.8499 20.3847 15.656C20.9149 15.6549 21.445 15.6555 21.9752 15.6501C22.0586 15.649 22.1566 15.6907 22.2243 15.5997L22.2265 15.5986ZM17.7766 13.0425C17.7002 13.1264 17.7343 13.2299 17.7332 13.3241C17.7284 14.0287 17.7273 14.7338 17.7251 15.4383C17.5166 15.2428 17.3991 14.9758 17.2226 14.7646C16.8429 14.3108 16.5023 13.8299 16.1535 13.355C15.847 12.9385 15.4972 12.8177 14.961 12.99C14.9042 13.0241 14.9118 13.0826 14.9118 13.1346C14.9134 14.496 14.9166 15.8575 14.9193 17.2189C14.9453 17.2531 14.9713 17.3164 14.9979 17.3164C15.2394 17.3197 15.4815 17.3505 15.7225 17.3018C15.8887 17.2682 15.9477 17.1794 15.9429 17.005C15.9304 16.5729 15.9385 16.1402 15.9385 15.7075C15.9385 15.4269 15.9385 15.1459 15.9385 14.7987C16.4183 15.4513 16.8413 16.0492 17.2892 16.6276C17.5773 16.9991 17.7988 17.48 18.4383 17.3392C18.6631 17.2899 18.7551 17.2124 18.7557 17.0099C18.7584 15.7481 18.7557 14.4868 18.7573 13.225C18.7573 13.1313 18.7476 13.0484 18.6642 12.9873C18.5407 12.8963 17.9141 12.9331 17.776 13.043L17.7766 13.0425Z"
          fill="white"
        />
        <path
          d="M16.538 7.46342C16.1573 7.46342 15.7766 7.46342 15.3964 7.46342C15.7771 7.38056 16.1578 7.37732 16.538 7.46342Z"
          fill="white"
        />
        <path
          d="M25.2088 15.3251C25.2088 15.0527 25.2083 14.7803 25.2077 14.5079C25.2922 14.7803 25.2976 15.0527 25.2088 15.3251Z"
          fill="white"
        />
        <path
          d="M14.961 12.99C15.4972 12.8177 15.847 12.938 16.1535 13.355C16.5028 13.8299 16.8429 14.3108 17.2225 14.7646C17.3996 14.9758 17.5171 15.2428 17.7256 15.4383C17.8161 15.4361 17.7841 15.3641 17.7841 15.3224C17.7836 14.5626 17.7798 13.8023 17.7765 13.0425C17.9146 12.9325 18.5412 12.8957 18.6647 12.9867C18.7481 13.0479 18.7578 13.1308 18.7578 13.2244C18.7568 14.4863 18.7589 15.7475 18.7562 17.0093C18.7562 17.2124 18.6641 17.2893 18.4389 17.3386C17.7993 17.4794 17.5773 16.9991 17.2897 16.627C16.8418 16.0486 16.4189 15.4508 15.9391 14.7982C15.9391 15.1459 15.9391 15.4264 15.9391 15.7069C15.9391 16.1396 15.9304 16.5723 15.9434 17.0045C15.9483 17.1789 15.8892 17.2677 15.723 17.3012C15.482 17.35 15.2399 17.3191 14.9984 17.3159C14.9719 17.3159 14.9464 17.2525 14.9199 17.2184C14.974 17.148 14.9632 17.0646 14.9632 16.9844C14.9632 15.6528 14.9621 14.3211 14.9616 12.9894L14.961 12.99Z"
          fill="white"
        />
        <path
          d="M20.3836 13.975C20.3728 14.4065 20.5791 14.6222 21.0026 14.6222C21.3253 14.6222 21.6481 14.6217 21.9709 14.6222C22.299 14.6233 22.3283 14.6525 22.3283 14.9715C22.3283 15.1058 22.3245 15.2406 22.3294 15.375C22.3326 15.4697 22.325 15.5537 22.2265 15.5986C21.7158 15.5986 21.2057 15.5986 20.695 15.6013C20.5905 15.6019 20.4778 15.5726 20.3863 15.6549C20.3863 15.8488 20.3863 16.0421 20.3857 16.236C20.4161 16.373 20.5266 16.3503 20.6208 16.3503C21.1553 16.3503 21.6903 16.3487 22.2249 16.347C22.3267 16.4683 22.3749 16.9622 22.2985 17.0982C22.2137 17.2494 22.0687 17.3251 21.8636 17.3251C21.1255 17.3251 20.3874 17.3251 19.6492 17.3251C19.5301 17.3251 19.405 17.3392 19.4045 17.1626C19.4088 16.6059 19.418 16.0492 19.4169 15.4925C19.4153 14.6931 19.4066 13.8944 19.4007 13.095C19.4158 12.9493 19.5209 12.9369 19.6352 12.9369C20.4421 12.9369 21.249 12.938 22.0564 12.9358C22.2568 12.9358 22.3657 13.0192 22.3272 13.2261C22.2844 13.4568 22.4545 13.7162 22.233 13.922C21.6811 13.9187 21.1293 13.9144 20.5775 13.9128C20.5081 13.9128 20.4323 13.9014 20.3847 13.974L20.3836 13.975Z"
          fill="white"
        />
        <path
          d="M12.4807 16.346C12.55 16.3725 12.6426 16.3075 12.6952 16.4007C12.6952 16.6747 12.6957 16.9487 12.6963 17.2233C12.6426 17.3348 12.5425 17.3262 12.4423 17.3262C11.6332 17.3251 10.8247 17.3262 10.0156 17.324C9.92405 17.324 9.80924 17.3581 9.77567 17.2184C9.8726 16.9005 9.80708 16.5756 9.81736 16.2544C9.85257 15.1665 9.75779 14.0769 9.87152 12.99C10.1103 12.8909 10.3595 12.9353 10.601 12.9575C10.7689 12.9726 10.7992 13.1151 10.7981 13.277C10.7927 14.2816 10.7981 15.2861 10.7997 16.2907C10.8593 16.3676 10.9454 16.3503 11.0234 16.3503C11.5086 16.3503 11.9944 16.3476 12.4796 16.346H12.4807Z"
          fill="white"
        />
        <path
          d="M14.2668 17.1686C14.2597 17.2791 14.1964 17.3251 14.0908 17.3251C13.8839 17.3251 13.6776 17.3202 13.4707 17.3256C13.3239 17.3294 13.2871 17.2493 13.2871 17.1231C13.2882 15.7936 13.2887 14.4635 13.2871 13.134C13.2871 12.9764 13.3656 12.9396 13.5064 12.938C13.6906 12.9358 13.8677 12.9163 14.0659 12.9141C14.1828 12.9125 14.2446 13.0035 14.2657 13.0447C14.2657 14.4197 14.2662 15.7941 14.2668 17.1691V17.1686Z"
          fill="white"
        />
        <path
          d="M9.87207 12.99C9.75835 14.0763 9.85312 15.1665 9.81792 16.2544C9.80763 16.5756 9.87316 16.901 9.77622 17.2184C9.77297 15.8846 9.77026 14.5513 9.76593 13.2174C9.76593 13.121 9.77839 13.0387 9.87207 12.99Z"
          fill="white"
        />
        <path
          d="M14.961 12.99C14.9616 14.3216 14.9626 15.6533 14.9626 16.985C14.9626 17.0651 14.9735 17.148 14.9193 17.2189C14.9166 15.8575 14.9134 14.496 14.9117 13.1346C14.9117 13.0826 14.9042 13.0241 14.961 12.99Z"
          fill="white"
        />
        <path
          d="M14.2668 17.1686C14.2668 15.7936 14.2662 14.4191 14.2657 13.0441C14.3388 13.0961 14.3144 13.1746 14.3144 13.2429C14.3161 14.4857 14.3161 15.7286 14.3144 16.9714C14.3144 17.0386 14.3431 17.1177 14.2668 17.1691V17.1686Z"
          fill="white"
        />
        <path
          d="M19.3996 13.0961C19.4055 13.8954 19.4142 14.6942 19.4158 15.4935C19.4169 16.0503 19.4077 16.607 19.4034 17.1637C19.3947 17.1388 19.3785 17.1139 19.3785 17.0884C19.3774 15.7833 19.3768 14.4781 19.3785 13.173C19.3785 13.1475 19.3925 13.1216 19.4001 13.0961H19.3996Z"
          fill="white"
        />
        <path
          d="M17.7766 13.0425C17.7798 13.8023 17.7836 14.5626 17.7841 15.3224C17.7841 15.3641 17.8161 15.4361 17.7256 15.4383C17.7278 14.7337 17.7284 14.0286 17.7338 13.3241C17.7343 13.2299 17.7002 13.1264 17.7771 13.0425H17.7766Z"
          fill="white"
        />
        <path
          d="M22.2243 16.347C21.6898 16.3481 21.1547 16.3503 20.6202 16.3503C20.526 16.3503 20.415 16.3736 20.3852 16.236C20.4653 16.3102 20.565 16.2972 20.6619 16.2972C21.0995 16.2972 21.5371 16.2951 21.9741 16.2988C22.058 16.2994 22.1544 16.2626 22.2243 16.347Z"
          fill="white"
        />
        <path
          d="M20.3836 13.975C20.4313 13.9025 20.5071 13.9133 20.5764 13.9138C21.1282 13.916 21.6801 13.9198 22.2319 13.923C22.0256 14.0173 21.8084 13.9577 21.5972 13.9642C21.1932 13.9767 20.7881 13.9723 20.3841 13.975H20.3836Z"
          fill="white"
        />
        <path
          d="M20.3863 15.6549C20.4778 15.5732 20.5905 15.6024 20.695 15.6013C21.2057 15.5981 21.7158 15.5992 22.2265 15.5986C22.1588 15.6896 22.0608 15.6479 21.9774 15.649C21.4472 15.6544 20.917 15.6539 20.3868 15.6549H20.3863Z"
          fill="white"
        />
        <path
          d="M12.4807 16.3459C11.9955 16.3476 11.5097 16.3503 11.0245 16.3503C10.9459 16.3503 10.8598 16.3676 10.8008 16.2907C11.2774 16.2929 11.7539 16.2929 12.23 16.2994C12.3139 16.3005 12.4114 16.2588 12.4807 16.3465V16.3459Z"
          fill="white"
        />
        <path
          d="M12.6968 17.2233C12.6968 16.9492 12.6963 16.6752 12.6957 16.4007C12.7829 16.6747 12.7824 16.9487 12.6968 17.2233Z"
          fill="white"
        />
        <path
          d="M12.6914 17.1702C12.6762 17.3635 12.5295 17.3245 12.4098 17.3245C11.546 17.3262 10.6828 17.3251 9.819 17.3251V12.9585C9.8607 12.9239 9.91052 12.9347 9.95818 12.9325C10.1813 12.9488 10.4071 12.8963 10.6275 12.9656C10.6535 13.0241 10.771 13.0132 10.7413 13.114C10.7938 13.3349 10.7613 13.5591 10.7629 13.7812C10.7678 14.5334 10.764 15.2861 10.7662 16.0383C10.7662 16.1255 10.7407 16.2176 10.7938 16.3005L10.7965 16.2945C11.0776 16.3687 11.364 16.3124 11.6473 16.3275C11.9592 16.3443 12.2733 16.3021 12.5847 16.3497C12.6594 16.3459 12.6963 16.3801 12.6908 16.4559C12.7271 16.6936 12.7266 16.9314 12.6908 17.1696L12.6914 17.1702Z"
          fill="#06C755"
        />
        <path
          d="M17.9369 12.9493C18.154 12.9493 18.3712 12.9504 18.5883 12.9504C18.6452 13.0073 18.7021 13.0641 18.7589 13.1216C18.7974 13.7996 18.7735 14.4776 18.7735 15.1556C18.7735 15.8244 18.7979 16.4943 18.7589 17.1632C18.6918 17.2818 18.5905 17.3099 18.4551 17.3327C17.9526 17.4161 17.6661 17.1832 17.4002 16.7797C16.9621 16.1158 16.4617 15.4925 15.9873 14.8524C15.8324 14.8724 15.9125 14.9921 15.912 15.0592C15.9049 15.675 15.9087 16.2913 15.9066 16.9075C15.9066 16.9953 15.9288 17.0863 15.8844 17.1707C15.88 17.1967 15.8844 17.2314 15.8692 17.2476C15.7463 17.3787 15.0574 17.3559 14.9166 17.2189C14.9562 16.9882 14.9329 16.7554 14.9339 16.5241C14.9372 15.4692 14.9356 14.4137 14.9339 13.3588C14.9339 13.2613 14.9513 13.1622 14.9161 13.0663C14.967 13.0279 15.0173 12.9894 15.0683 12.9515C15.3022 12.9564 15.5362 12.9618 15.7701 12.9667C16.0652 13.1725 16.2023 13.5055 16.4221 13.7714C16.8559 14.2967 17.2041 14.887 17.6634 15.3928C17.7435 15.4015 17.7489 15.3457 17.7484 15.291C17.7386 14.5485 17.7733 13.8055 17.7305 13.0636C17.7803 12.9916 17.8562 12.9661 17.9369 12.9499V12.9493Z"
          fill="#06C755"
        />
        <path
          d="M19.5604 12.9499C20.4269 12.9499 21.2939 12.9499 22.1604 12.9499C22.2173 13.0062 22.2741 13.0631 22.3305 13.1194C22.3586 13.3533 22.3581 13.5878 22.3305 13.8218C22.2931 13.8591 22.2563 13.8965 22.2189 13.9339C21.7109 13.981 21.2019 13.9398 20.6934 13.9561C20.5986 13.9593 20.4968 13.922 20.4085 13.988C20.3917 14.1987 20.3944 14.4099 20.4074 14.6206C20.624 14.7002 20.8477 14.6433 21.0681 14.6552C21.4337 14.6747 21.8008 14.6298 22.1653 14.6801C22.2482 14.6753 22.2947 14.7245 22.3299 14.7901C22.3581 15.024 22.3581 15.2585 22.3299 15.4925C22.2931 15.5293 22.2563 15.5661 22.2194 15.6029C21.7115 15.6538 21.2024 15.61 20.6939 15.6268C20.5986 15.63 20.4973 15.5927 20.4085 15.6587C20.3917 15.8694 20.3944 16.0806 20.4069 16.2918C20.623 16.3719 20.8472 16.3151 21.067 16.3265C21.4326 16.3454 21.7997 16.3026 22.1648 16.3497C22.2465 16.3476 22.2936 16.3958 22.3294 16.4613C22.3586 16.6953 22.3575 16.9297 22.3299 17.1637C22.2584 17.2996 22.1442 17.3289 21.9952 17.3278C21.2208 17.3207 20.4464 17.3251 19.672 17.3245C19.5485 17.3245 19.4077 17.3527 19.3904 17.1659C19.3514 16.881 19.3747 16.5945 19.3736 16.3091C19.3698 15.3246 19.3714 14.3406 19.3736 13.356C19.3736 13.2586 19.3568 13.1589 19.3909 13.0631C19.4261 12.9937 19.4814 12.9531 19.5604 12.9493V12.9499Z"
          fill="#06C755"
        />
        <path
          d="M13.4442 12.9504C13.6781 12.9558 13.9121 12.9613 14.1455 12.9661C14.1742 13.0235 14.2857 13.016 14.2619 13.1145C14.302 13.2098 14.2819 13.3095 14.2819 13.407C14.2836 14.5637 14.2836 15.7205 14.2819 16.8772C14.2819 16.9747 14.3014 17.0743 14.2619 17.1697C14.2532 17.2596 14.2148 17.3229 14.1141 17.324C13.8893 17.3256 13.6651 17.3251 13.4404 17.3251C13.3055 17.3251 13.2822 17.2395 13.2822 17.128C13.2833 15.8033 13.2855 14.4792 13.2784 13.1546C13.2779 13.0187 13.3738 13.0051 13.4442 12.9504Z"
          fill="#06C755"
        />
        <path
          d="M14.9161 13.0658C14.9832 13.1324 14.9599 13.2174 14.9599 13.2959C14.961 14.5269 14.961 15.7578 14.9599 16.9882C14.9599 17.0667 14.9827 17.1518 14.9161 17.2184C14.9161 15.8342 14.9161 14.45 14.9161 13.0658Z"
          fill="#06C755"
        />
        <path
          d="M14.2624 17.1696C14.2624 15.8179 14.2624 14.4662 14.2624 13.1145C14.3301 13.1567 14.3106 13.225 14.3106 13.2845C14.3117 14.5231 14.3117 15.7611 14.3106 16.9996C14.3106 17.0592 14.3301 17.1279 14.2624 17.1696Z"
          fill="#06C755"
        />
        <path
          d="M10.7943 16.301C10.7164 16.2409 10.7402 16.1542 10.7402 16.0762C10.7402 15.089 10.7413 14.1018 10.7418 13.1145C10.8404 13.1898 10.79 13.2965 10.7905 13.3869C10.7954 14.3584 10.7938 15.33 10.7943 16.3015V16.301Z"
          fill="#3CB159"
        />
        <path
          d="M15.8833 17.1702C15.8822 16.4212 15.8811 15.6728 15.8822 14.9238C15.8822 14.8686 15.8508 14.7874 15.9391 14.7706C15.9781 14.763 15.9813 14.8177 15.9868 14.8524C15.8849 14.9146 15.9386 15.0137 15.938 15.0939C15.9331 15.7037 15.9375 16.3135 15.9326 16.9232C15.9321 17.0056 15.9781 17.1041 15.8833 17.1702Z"
          fill="#3CB158"
        />
        <path
          d="M20.3803 13.9875C20.4253 13.9046 20.5049 13.9306 20.5726 13.9306C21.1217 13.9306 21.6703 13.9328 22.2194 13.935C22.1106 14.0324 21.9795 13.9783 21.8604 13.9804C21.3849 13.9891 20.9094 13.9869 20.434 13.9886C20.4155 14.0097 20.3977 14.0097 20.3803 13.9875Z"
          fill="#7DC48E"
        />
        <path
          d="M20.3787 15.6614C20.4334 15.5737 20.5222 15.6019 20.5991 15.6013C21.1396 15.6002 21.6801 15.6024 22.22 15.604C22.1518 15.6945 22.0537 15.6511 21.9703 15.6522C21.458 15.6587 20.9452 15.6593 20.4329 15.6614C20.4145 15.6815 20.3966 15.6804 20.3782 15.6614H20.3787Z"
          fill="#57B76E"
        />
        <path
          d="M22.1658 14.6807C21.6432 14.6818 21.1206 14.6839 20.598 14.6828C20.5206 14.6828 20.4323 14.7094 20.3771 14.6227C20.3955 14.6032 20.4139 14.6032 20.4323 14.6227C20.9273 14.6249 21.4217 14.6254 21.9167 14.6325C21.9996 14.6336 22.0981 14.5886 22.1653 14.6812L22.1658 14.6807Z"
          fill="#4BB464"
        />
        <path
          d="M22.1658 16.3503C21.6346 16.3519 21.1033 16.3541 20.5726 16.3541C20.5043 16.3541 20.4253 16.3774 20.3798 16.2961C20.3977 16.2755 20.4155 16.2745 20.4339 16.2956C20.9278 16.2978 21.4217 16.2972 21.9151 16.3032C21.999 16.3042 22.096 16.2636 22.1658 16.3503Z"
          fill="#70BF84"
        />
        <path
          d="M20.4329 14.6227C20.4144 14.6227 20.396 14.6227 20.3776 14.6227C20.3787 14.411 20.3792 14.1992 20.3803 13.9875C20.3982 13.9848 20.4161 13.9848 20.4339 13.9886C20.4339 14.2003 20.4334 14.4115 20.4329 14.6233V14.6227Z"
          fill="#AFD9BA"
        />
        <path
          d="M20.4334 16.2956C20.4155 16.2956 20.3971 16.2956 20.3793 16.2961C20.3793 16.0844 20.3787 15.8732 20.3782 15.6614C20.3966 15.6614 20.4145 15.6614 20.4329 15.6614C20.4329 15.8726 20.4329 16.0844 20.4329 16.2956H20.4334Z"
          fill="#AFD9BA"
        />
        <path
          d="M17.73 13.0631C17.7777 13.1026 17.7749 13.1578 17.7749 13.2115C17.7749 13.9122 17.776 14.6125 17.7733 15.3132C17.7733 15.3679 17.808 15.4491 17.7186 15.4692C17.6737 15.4789 17.6742 15.4242 17.6628 15.3923C17.7636 15.3192 17.7175 15.2119 17.7186 15.1204C17.7257 14.4348 17.7267 13.7487 17.73 13.0625V13.0631Z"
          fill="#06C755"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_825_4478">
        <rect width="32" height="32" fill="white" />
      </clipPath>
      <clipPath id="clip1_825_4478">
        <rect
          width="18.5465"
          height="17.66"
          fill="white"
          transform="translate(6.72675 7.39999)"
        />
      </clipPath>
    </defs>
  </svg>
)

/**
 * https://www.figma.com/file/rhD2WrlY4tesD0yX6zpzs3/%5BProject%5D-Giant-ID?node-id=1433%3A13848&t=CjnwXjtALmvo5v7n-4
 * @type {React.FC<React.SVGAttributes<SVGElement> & {fillClassName?: string}>}
 */
export const Unselected = ({fillClassName, ...props}) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width="64"
      height="64"
      rx="32"
      fill="#AAB7D5"
      className={fillClassName}
    />
    <path
      d="M23.1127 23.1128L40.8873 40.8873"
      stroke="white"
      strokeWidth="3.8"
      strokeLinecap="round"
    />
    <path
      d="M40.8873 23.1128L23.1127 40.8873"
      stroke="white"
      strokeWidth="3.8"
      strokeLinecap="round"
    />
  </svg>
)

/**
 * https://www.figma.com/file/rhD2WrlY4tesD0yX6zpzs3/%5BProject%5D-Giant-ID?node-id=1433%3A13848&t=CjnwXjtALmvo5v7n-4
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Family = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1346_9132)">
      <circle cx="16" cy="16" r="16" fill="#D9E2EA" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7364 15.5853H23.5442C24.5085 15.5853 24.9501 14.3838 24.2154 13.7593L16.6712 7.34672C16.2842 7.01777 15.7158 7.01777 15.3288 7.34672L7.78461 13.7593C7.04988 14.3838 7.49152 15.5853 8.45581 15.5853H9.26364V22.8399C9.26364 23.4122 9.72763 23.8762 10.3 23.8762H14.1V19.1262C14.1 18.6015 14.5253 18.1762 15.05 18.1762H16.95C17.4747 18.1762 17.9 18.6015 17.9 19.1262V23.8762H21.7C22.2724 23.8762 22.7364 23.4122 22.7364 22.8399V15.5853Z"
        fill="#353F58"
      />
    </g>
    <defs>
      <clipPath id="clip0_1346_9132">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * https://www.figma.com/file/rhD2WrlY4tesD0yX6zpzs3/%5BProject%5D-Giant-ID?node-id=1433%3A13848&t=CjnwXjtALmvo5v7n-4
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const FamilyDark = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6488_32322)">
      <circle cx="16" cy="16" r="16" fill="#5A6D96" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7364 15.5854H23.5442C24.5085 15.5854 24.9501 14.3839 24.2154 13.7594L16.6712 7.34682C16.2842 7.01786 15.7158 7.01786 15.3288 7.34682L7.78461 13.7594C7.04988 14.3839 7.49152 15.5854 8.45581 15.5854H9.26364V22.84C9.26364 23.4123 9.72763 23.8763 10.3 23.8763H14.1V19.1263C14.1 18.6016 14.5253 18.1763 15.05 18.1763H16.95C17.4747 18.1763 17.9 18.6016 17.9 19.1263V23.8763H21.7C22.2724 23.8763 22.7364 23.4123 22.7364 22.84V15.5854Z"
        fill="#EFF2F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_6488_32322">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<{
 *    i?: number
 * } & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>>}
 */
export const Number = ({i = 1, className = "", ...props}) => {
  return (
    <div
      className={`w-8 h-8 lg:w-6 lg:h-6 rounded-full flex items-center justify-center bg-gray-light dark:bg-blue-night ${className}`}
      {...props}
    >
      <span className="typo-subtitle lg:text-sm">{i}</span>
    </div>
  )
}

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Camera = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3463_21923)">
      <circle
        cx="16"
        cy="16"
        r="15"
        fill="#D9E2EA"
        stroke="white"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 10C8.44772 10 8 10.4477 8 11V21C8 21.5523 8.44772 22 9 22H23C23.5523 22 24 21.5523 24 21V11C24 10.4477 23.5523 10 23 10H9ZM16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19Z"
        fill="#353F58"
      />
      <path
        d="M12.5 10C12.5 9.44772 12.9477 9 13.5 9H18.5C19.0523 9 19.5 9.44772 19.5 10C19.5 10.5523 19.0523 11 18.5 11H13.5C12.9477 11 12.5 10.5523 12.5 10Z"
        fill="#353F58"
      />
    </g>
    <defs>
      <clipPath id="clip0_3463_21923">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const CameraDark = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6488_32524)">
      <circle cx="16" cy="16" r="16" fill="#5A6D96" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 10C8.44772 10 8 10.4477 8 11V21C8 21.5523 8.44772 22 9 22H23C23.5523 22 24 21.5523 24 21V11C24 10.4477 23.5523 10 23 10H9ZM16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19Z"
        fill="#EFF2F7"
      />
      <path
        d="M12.5 10C12.5 9.44772 12.9477 9 13.5 9H18.5C19.0523 9 19.5 9.44772 19.5 10C19.5 10.5523 19.0523 11 18.5 11H13.5C12.9477 11 12.5 10.5523 12.5 10Z"
        fill="#EFF2F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_6488_32524">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const AddMemberIcon = props => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="1.5" y="1.5" width="61" height="61" rx="30.5" fill="#EFF2F7" />
    <path
      d="M20 32H44"
      stroke="#005EB8"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <path
      d="M32 20L32 44"
      stroke="#005EB8"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <rect
      x="1.5"
      y="1.5"
      width="61"
      height="61"
      rx="30.5"
      stroke="#EFF2F7"
      strokeWidth="3"
    />
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const AddMemberIconDark = props => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="1.5" y="1.5" width="61" height="61" rx="30.5" fill="#5A6D96" />
    <rect
      x="1.5"
      y="1.5"
      width="61"
      height="61"
      rx="30.5"
      stroke="#5A6D96"
      strokeWidth="3"
    />
    <path
      d="M20 32H44"
      stroke="#FFFFFF"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <path
      d="M32 20L32 44"
      stroke="#FFFFFF"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
)
